import type {ReactElement} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize, InputFieldState} from '@Components/input-field-v2/input-field.types';
import {SURVEY_FIELD_ERROR_ID_PREFIX} from '@Components/ai-chat-window/components/survey/survey.types';
import type {TextFieldRendererProps} from './fields.types';
import styles from './fields.module.scss';

export function TextFieldRenderer({name, step, field}: TextFieldRendererProps): ReactElement {
  const {control} = useFormContext();
  const required = step.required !== false;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      rules={{
        required: required ? window.i18next.t('pmwjs_required') : false,
        maxLength: field.maxLength,
      }}
      render={({field: rhfField, fieldState}): ReactElement => {
        const value = typeof rhfField.value === 'string' ? rhfField.value : '';
        return (
          <InputField
            isMultiline
            useEmptyPlaceholder
            inputClassName={`_borderless ${styles.textArea}`}
            placeholder={field.placeholder}
            input={value}
            size={InputFieldSize.MEDIUM}
            maxLength={field.maxLength}
            maxNumberOfRows={2}
            elementTitle={step.helpText}
            state={fieldState.invalid ? InputFieldState.ERROR : InputFieldState.DEFAULT}
            describedById={fieldState.invalid ? `${SURVEY_FIELD_ERROR_ID_PREFIX}${name}` : undefined}
            onInputChange={(val): void => {
              rhfField.onChange(String(val));
            }}
            onInputBlur={(): void => {
              rhfField.onBlur();
            }}
          />
        );
      }}
    />
  );
}
